import { Component } from '@theme/component';

/**
 * Interactive pillow comparison tool. Every pillow's markup for every column
 * is already server-rendered (see sections/cariloha-pillow-compare.liquid) —
 * this only toggles the `hidden` attribute to match each column's <select>,
 * and disables options already chosen in another column so the same pillow
 * can't be compared against itself.
 *
 * @extends {Component}
 */
class CarilohaPillowCompare extends Component {
  connectedCallback() {
    super.connectedCallback();

    for (const select of this.querySelectorAll('[data-compare-select]')) {
      select.addEventListener('change', this.#handleChange);
    }

    this.#syncDisabledOptions();
  }

  /**
   * @param {Event} event
   */
  #handleChange = (event) => {
    const select = /** @type {HTMLSelectElement} */ (event.currentTarget);
    const col = select.dataset.col;

    for (const panel of this.querySelectorAll(`[data-compare-panel][data-col="${col}"]`)) {
      for (const cell of panel.querySelectorAll('[data-pillow]')) {
        cell.toggleAttribute('hidden', /** @type {HTMLElement} */ (cell).dataset.pillow !== select.value);
      }
    }

    this.#syncDisabledOptions();
  };

  /**
   * Prevents selecting the same pillow in more than one column.
   */
  #syncDisabledOptions() {
    const selects = /** @type {HTMLSelectElement[]} */ ([...this.querySelectorAll('[data-compare-select]')]);
    const chosen = selects.map((select) => select.value);

    for (const select of selects) {
      for (const option of select.options) {
        option.disabled = option.value !== select.value && chosen.includes(option.value);
      }
    }
  }
}

if (!customElements.get('cariloha-pillow-compare')) {
  customElements.define('cariloha-pillow-compare', CarilohaPillowCompare);
}
